import React from 'react';
import merge from 'classnames';

import { Props } from './types';

import styles from './InputGroup.module.scss';

export const InputGroup = (props: Props) => (
  <div className={merge(styles.container, props.className)} data-testid="input-group">
    {props.children}
  </div>
);
